/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// Add to cart event

async function gtagAddToCart(price) {
return gtag('event', 'conversion', {
      'send_to': 'AW-10936957785/6NcDCL2d3McDENn2kt8o',
  		'value': price,
      'currency': Shopify.currency.active,
  	});
}

async function addToCartEvent(e) {
  
  e.preventDefault();
  
  	const price = parseFloat(Number(e.target.dataset.price) / 100).toFixed(2); // Find the element by its data-scr
  	await console.log('Sending event')
    console.log(price)
    
    await gtagAddToCart(price)
  
   	await console.log('Event sent!')

  
  	document.getElementById("product-form").submit();
}

const fireEvent = document.getElementById('add_to_cart_event');

fireEvent.addEventListener('click', (e) => {addToCartEvent(e)})



// Start checkout ga #############################################################
// ###############################################################################

async function pushConversion(currency, price) {
  console.log('Conversion tracker sent!')
  gtag('event', 'conversion', {
      'send_to': 'AW-10936957785/DpWQCLqd3McDENn2kt8o',
    'value': price,
    'currency': currency
  });
}

function startCheckout() {
  fetch("/cart.js")
    .then((response) => {
      return response.json();
    })
    .then(async (response) => {
      console.log(response);
      const currency = response.currency;
      const total_price = response.total_price / 100;
  		const form = document.getElementById('checkout_form');

      await pushConversion(currency, total_price).then(() => {
        setTimeout(() => {
          window.location.href = '/checkout';
        }, 1000);
      });

    })
    .catch((error) => {
      console.error(error);
    });

}
